export default {
    'username': 'Usuario',
    'password': 'Contraseña',
    'sign-in': 'Iniciar Sesión',
    'select-financial-file': 'Eligir archivo financiero',
    'show-financial-file': 'Explorar archivo financiero',
}